import { createFeatureSelector, createSelector } from '@ngrx/store';
import { promiseOfPaymentFeatureKey } from '../reducers';
import { PromiseOfPaymentState } from '../reducers/promise-of-payment.reducer';

export const selectPromiseOfPaymentState =
  createFeatureSelector<PromiseOfPaymentState>(promiseOfPaymentFeatureKey);

export const selectPromiseOfPayment = (billingAccountNumber: string) =>
  createSelector(
    selectPromiseOfPaymentState,
    (state) => state.byAccountNumber[billingAccountNumber]
  );
